import React from 'react';
import { Fuel, Zap, Cog, TrendingUp, Globe, Shield } from 'lucide-react';
const services = [{
  icon: <Fuel size={32} data-id="element-154" />,
  title: 'Energy Trading',
  description: 'Wholesale trading solutions for energy products across international markets with established networks and reliable execution.'
}, {
  icon: <TrendingUp size={32} data-id="element-155" />,
  title: 'Wholesale Trade',
  description: 'Comprehensive wholesale trading services connecting suppliers and buyers with efficient coordination and market expertise.'
}, {
  icon: <Zap size={32} data-id="element-156" />,
  title: 'EV Solutions',
  description: 'Electric vehicle components and SKD assembly solutions supporting the transition to sustainable mobility.'
}, {
  icon: <Cog size={32} data-id="element-157" />,
  title: 'Automotive Parts',
  description: 'Trading and distribution of automotive components with focus on quality, reliability, and timely delivery.'
}, {
  icon: <Globe size={32} data-id="element-158" />,
  title: 'Market Facilitation',
  description: 'Strategic approaches to market opportunities across energy and automotive sectors with international reach.'
}, {
  icon: <Shield size={32} data-id="element-159" />,
  title: 'Compliance & Standards',
  description: 'Adherence to international trading standards and regulatory requirements across all operations and sectors.'
}];
export function ServicesSection() {
  return <section id="services" className="py-20 md:py-32 bg-[#f9f9f7]" data-id="element-160">
      <div className="container mx-auto px-4 md:px-6" data-id="element-161">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a4d5c] mb-4" data-id="element-163">
            What We Do
          </h2>
          <div className="w-20 h-1 bg-[#d4a017] mx-auto mb-6" data-id="element-164"></div>
          <p className="text-gray-600 text-lg" data-id="element-165">
            Comprehensive trading solutions across energy, automotive, and
            mobility sectors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-166">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 border-b-4 border-transparent hover:border-[#d4a017] group" data-id="element-167">
              <div className="w-14 h-14 bg-[#1a4d5c]/10 rounded-lg flex items-center justify-center text-[#1a4d5c] mb-6 group-hover:bg-[#1a4d5c] group-hover:text-white transition-colors" data-id="element-168">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1a4d5c] mb-3" data-id="element-169">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-170">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}